const UPDATE_CHART = (context, payload) => {
    context.commit("UPDATE_CHART", payload)
}
const UPDATE_TOP_10_COINS = (context, payload) => {
    context.commit("UPDATE_TOP_10_COINS", payload)
}
const UPDATE_PROCESSED_SPARKLINE_DATA = (context, payload) => {
    context.commit("UPDATE_PROCESSED_SPARKLINE_DATA", payload)
}

export default {
    UPDATE_CHART,
    UPDATE_TOP_10_COINS,
    UPDATE_PROCESSED_SPARKLINE_DATA
}


// WEBPACK FOOTER //
// ./src/store/actions.js